export default {
  List: {
    Inward: 'Nhập kho',
    Outward: 'Xuất kho',
  },
  Detail: {
    Title: 'Vật tư',
    InventoryItemCode: 'Mã vật tư *',
    InventoryItemName: 'Tên vật tư *',
    InventoryCategoryName: 'Loại vật tư/CCDC *',
    InventoryCategoryNameTooltip: 'Loại vật tư/Công cụ dụng cụ',
    Unit: 'Đơn vị tính',
    UnitPrice: 'Đơn giá',
    Stock: 'Kho *',
    Description: 'Diễn giải',
  },
};
